import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { Link } from 'react-router-dom'

export interface BreadcrumbsPath {
  title: string
  to: string
}

interface BreadcrumbsProps {
  children?: React.ReactNode
  sx?: any
  style?: any
  pathArray?: BreadcrumbsPath[]
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { children, style, pathArray } = props
  const [pathLinks, setPathLinks] = useState<BreadcrumbsPath[]>([])

  const lastPathArrayItem = useMemo(
    () => pathArray && pathArray[pathArray.length - 1],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(() => {
    if (pathArray) {
      const sliceable = JSON.parse(JSON.stringify(pathArray))

      sliceable?.pop()
      setPathLinks(sliceable || [])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathArray])

  if (!pathArray && !lastPathArrayItem && children)
    return (
      <MuiBreadcrumbs
        style={style}
        sx={{ display: { xs: 'none', sm: 'flex' } }}
        aria-label="breadcrumb"
        separator={<MdKeyboardArrowRight size={18} />}
      >
        {children}
      </MuiBreadcrumbs>
    )

  return (
    <MuiBreadcrumbs
      style={style}
      sx={{ display: { xs: 'none', sm: 'flex' } }}
      aria-label="breadcrumb"
      separator={<MdKeyboardArrowRight size={18} />}
    >
      {pathLinks?.map((path, index) => (
        <Link
          key={index}
          to={path.to}
          color="#262626"
          style={{ color: '#595959' }}
        >
          {path.title}
        </Link>
      ))}
      <span style={{ color: '#595959' }}>{lastPathArrayItem?.title}</span>
    </MuiBreadcrumbs>
  )
}
